// All site content sourced from the Aarambh Buildworks company profile + brief.
// Placeholder imagery uses abstract architectural motifs — easy to swap later.

export const BRAND = {
  name: "Aarambh Buildworks",
  tagline: "Building Stronger Tomorrows, Together.",
  positioning:
    "A process-driven, full turnkey construction and interior fit-out partner — architectural rigour, precise costing and reliable execution, from brief to handover.",
};

export const NAV = [
  { id: "hero", label: "Home" },
  { id: "about", label: "Studio" },
  { id: "capabilities", label: "Capabilities" },
  { id: "projects", label: "Work" },
  { id: "process", label: "Process" },
  { id: "timeline", label: "Journey" },
  { id: "contact", label: "Contact" },
];

export const SATYA = [
  { letter: "S", word: "Sincere", note: "We approach every task with genuine intent and honesty." },
  { letter: "A", word: "Accountable", note: "We take full responsibility for our work and outcomes." },
  { letter: "T", word: "Transparent", note: "We communicate clearly and openly with clients." },
  { letter: "Y", word: "Yearnful", note: "We stay motivated, eager, and proactive in every project." },
  { letter: "A", word: "Attentive", note: "We pay close attention to details, people, and process." },
];

export const TEAM = [
  { name: "Ashish Sarvesh Jain", role: "Managing Director" },
  { name: "Ar. Ishika Singhal", role: "Principal Architect" },
  { name: "Himanshu Jain", role: "Chief Engineer" },
];

const P = (n) => `/photos/p${String(n).padStart(3, "0")}.jpg`;

export const HERO_IMG = P(20); // illuminated corridor

export const GALLERY = [24, 42, 31, 91, 112, 132, 149, 162, 133, 47].map(P);

export const CAPABILITIES = [
  {
    no: "01",
    title: "Commercial Office Fit-outs",
    detail:
      "Turnkey delivery across civil, electrical, networking, HVAC and furniture — full execution management, end to end.",
    img: P(142),
  },
  {
    no: "02",
    title: "Retail & Showroom Fit-outs",
    detail:
      "Brand-standard finishes delivered to demanding timelines — including 15-day turnkey showroom rollouts.",
    img: P(120),
  },
  {
    no: "03",
    title: "Premium Residential Renovation",
    detail:
      "Full-home transformations: civil, false ceiling, electrical, plumbing, kitchens, flooring, joinery — quotation-driven and precise.",
    img: P(129),
  },
  {
    no: "04",
    title: "Fitness, Wellness & Specialty Spaces",
    detail:
      "High-end spaces built to exacting standards — including premium fit-outs at India's most prestigious addresses.",
    img: P(26),
  },
];

export const PROJECTS = [
  {
    id: "sewa-call",
    index: "01",
    name: "Sewa Call Office",
    location: "Janakpuri, Delhi — JP Novations",
    tag: "Commercial Fit-out",
    stat: "250 sq. yd. · Turnkey",
    brief: "A 2nd-floor commercial office requiring a complete, move-in-ready workspace.",
    challenge: "Coordinating civil, electrical, networking, HVAC and furniture within a single managed timeline.",
    approach: "End-to-end execution management — one accountable team from bare floor to handover.",
    result: "A fully operational office delivered turnkey, on brief and on schedule.",
    before: "/photos/sewa-before.jpg",
    after: "/photos/sewa-after.jpg",
  },
  {
    id: "acer-ev",
    index: "02",
    name: "Acer Electric Vehicle Showroom",
    location: "Lucknow",
    tag: "Retail / Showroom",
    stat: "15-day Turnkey",
    brief: "A brand-standard EV showroom to launch on an aggressive timeline.",
    challenge: "Delivering premium retail finish quality in just 15 days.",
    approach: "Tight sequencing, pre-procured materials and a dedicated execution crew working to a fixed plan.",
    result: "A showroom-ready EV space handed over in 15 days, to brand specification.",
    before: "/photos/acer-before.jpg",
    after: "/photos/acer-after.jpg",
  },
  {
    id: "camellias-gym",
    index: "03",
    name: "DLF Camellias Gym",
    location: "Gurugram",
    tag: "Fitness / Wellness",
    stat: "Premium Address",
    brief: "A private fitness space within one of Gurugram's most exclusive residences.",
    challenge: "Meeting the finish quality and discretion expected at a landmark luxury address.",
    approach: "High-end materials, precise detailing and careful on-site conduct throughout.",
    result: "A refined, high-specification space built to premium standards.",
    noPhotos: true,
    privacyNote: "At the client's request, no photography was permitted on site — a discretion we respected in full. The work speaks through the standard it was held to.",
  },
  {
    id: "residential",
    index: "04",
    name: "Residential Renovations",
    location: "South & West Delhi",
    tag: "Home Transformation",
    stat: "Full-home · Design-led",
    brief: "Complete ground-floor and multi-room renovations for homeowners.",
    challenge: "Blending civil, false ceiling, electrical, plumbing, kitchen and flooring into one seamless renovation.",
    approach: "A quotation-driven, GFC-drawing-led process aligned with clients before any work on site.",
    result: "Homes transformed with precision — professional, reliable, and design-led throughout.",
    before: "/photos/res-before.jpg",
    after: "/photos/res-after.jpg",
  },
];

export const PROCESS = [
  { no: "01", title: "Brief", text: "We listen first — understanding intent, lifestyle and constraints before drawing a single line." },
  { no: "02", title: "Design", text: "Thoughtful design and detailed GFC drawings, always aligned with the client before site work begins." },
  { no: "03", title: "Costing / BOQ", text: "Transparent, quotation-driven costing — no surprises, no ad-hoc pricing." },
  { no: "04", title: "Execution", text: "Structured, managed execution across civil, MEP and finishes by our own accountable team." },
  { no: "05", title: "Handover", text: "A clean handover — and an ongoing relationship through repair and maintenance." },
];

export const STATS = [
  { value: 50, suffix: "+", label: "Projects Delivered", sub: "Since inception" },
  { value: 10, suffix: "+", label: "Dedicated Supervisors", sub: "On-ground execution" },
  { value: 100, suffix: "+", label: "Material Vendors", sub: "Procurement network" },
  { value: 3, suffix: "", label: "Cities", sub: "Meerut · Noida · Gurgaon" },
];

export const CREDIBILITY =
  "Through our associated entity, the group has executed across 50+ sites pan-India for PVR INOX and hospitality projects for Clarks Inn — proof of national-scale, brand-standard delivery.";

export const TIMELINE = [
  { year: "Origins", title: "Shreejee Enterprises", text: "A family-owned firm with strong roots in construction and interiors." },
  { year: "Scale", title: "PVR INOX & Clarks Inn", text: "50+ sites pan-India across construction, interiors, HVAC and MEP — and hospitality delivery for Clarks Inn, at brand standard." },
  { year: "New perspective", title: "Aarambh Buildworks", text: "Founded as a dedicated construction and interior fit-out firm — with a fresher perspective and a bolder vision." },
  { year: "Today", title: "Multi-vertical Capability", text: "Offices, retail, residential and wellness — turnkey, under one accountable roof." },
];

export const CONTACT = {
  email: "sales@aarambhbuildworks.com",
  phones: ["+91 70179 35951", "+91 74520 60606"],
  offices: [
    { city: "Meerut", area: "Transport Nagar" },
    { city: "Noida", area: "Sector 73" },
    { city: "Gurgaon", area: "Sector 52" },
  ],
  projectTypes: ["Commercial Fit-out", "Retail / Showroom", "Residential Renovation", "Fitness / Wellness", "Turnkey Construction", "Other"],
};
